export const ListingMenuErrorCode = {
  MenuNotFound: 'MenuNotFound',
  MenuScanUnavailable: 'MenuScanUnavailable',
  MenuScanFailed: 'MenuScanFailed',
  MenuFileUnsupported: 'MenuFileUnsupported',
  MenuFileTooLarge: 'MenuFileTooLarge',
  TooManyMenuFiles: 'TooManyMenuFiles',
} as const
export type ListingMenuErrorCode = (typeof ListingMenuErrorCode)[keyof typeof ListingMenuErrorCode]
